import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { MobileSecurityCompanyGridDataProviderFactory } from '../factory/MobileSecurityCompanyGridDataProviderFactory';
import { MobileSecurityCompanyGridDataProvider } from '../dataProvider/MobileSecurityCompanyGridDataProvider';
import { MobileSecurityCompanyGridWebComponentSchema, MobileSecurityCompanyRecord } from '../types';

export class MobileSecurityCompanyGridRepository extends BaseWebComponentRepository {
  public dataProviderFactory: MobileSecurityCompanyGridDataProviderFactory;
  public dataProvider: MobileSecurityCompanyGridDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new MobileSecurityCompanyGridDataProviderFactory(),
    });
  }

  public async getDataForView(): Promise<MobileSecurityCompanyGridWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  public async createAccount(companyId: string): Promise<{ success: boolean }> {
    return this.dataProvider.createAccount(companyId);
  }

  public async getCompanies(): Promise<[MobileSecurityCompanyRecord]> {
    return this.dataProvider.getCompanies();
  }
}
